import { customTokens } from "../../theme/theme";

export const colors = [
  customTokens.UNFCCCBrandGraphLevel1,
  customTokens.UNFCCCBrandGraphLevel2,
  customTokens.UNFCCCBrandGraphLevel3,
  customTokens.UNFCCCBrandGraphLevel4,
  customTokens.UNFCCCBrandGraphLevel5,
  customTokens.UNFCCCBrandGraphLevel6,
  customTokens.UNFCCCBrandGraphLevel7,
  customTokens.UNFCCCBrandGraphLevel8,
  customTokens.UNFCCCBrandGraphLevel9,
];

export interface IBarConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    x: {
      field: string;
      label: string;
    };
    y: {
      field: string;
      label: string;
      aggregation: string;
    };
    series: string;
  };
  sql_query: string;
}

export interface IStackedAreaConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    x: {
      field: string;
      label: string;
    };
    y: {
      field: string;
      label: string;
      aggregation: string;
    };
    stack: {
      field: string;
      label: string;
    };
  };
  sql_query: string;
}

export interface IScatterChartConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    x: {
      field: string;
      label: string;
    };
    y: {
      field: string;
      label: string;
    };
  };
  sql_query: string;
}

export interface ITwoLevelPieChartConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    level1: {
      field: string;
      label: string;
    };
    level2: {
      field: string;
      label: string;
    };
    values: {
      field: string;
      label: string;
      aggregation: string;
    };
  };
  sql_query: string;
}

export interface IRadarChart {
  chart_type: string;
  title: string;
  description: string;
  data: {
    categories: {
      field: string;
      label: string;
    };
    values: {
      field: string;
      label: string;
      aggregation: string;
    };
    series?: string;
  };
  sql_query: string;
}

export interface ISankeyChartConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    levels: {
      source: {
        field: string;
        label: string;
      };
      target: {
        field: string;
        label: string;
      };
      value: {
        field: string;
        label: string;
      };
    }[];
  };
  sql_query: string;
}

export interface ITreeMapChartConfig {
  chart_type: string;
  title: string;
  description?: string;
  data: {
    level1: { field: string; label: string };
    level2?: { field: string; label: string };
    values: {
      field: string;
      label: string;
      aggregation: string;
    };
  };
  sql_query?: string;
}

export interface IStackedBarConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    x: {
      field: string;
      label: string;
    };
    y: {
      field: string;
      label: string;
      aggregation: string;
    };
    stack: {
      field: string;
      label: string;
    };
  };
  sql_query: string;
}

export interface IBiaxialChartConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    x: {
      field: string;
      label: string;
    };
    y1: {
      field: string;
      label: string;
      aggregation: string;
    };
    y2: {
      field: string;
      label: string;
      aggregation: string;
    };
  };
  sql_query: string;
}

export interface IAreaChartConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    x: {
      field: string;
      label: string;
    };
    y: {
      field: string;
      label: string;
      aggregation: string;
    };
    series: string;
  };
  sql_query: string;
}

export interface IPieChartConfig {
  chart_type: string;
  title: string;
  description: string;
  data: {
    labels: {
      field: string;
      label: string;
    };
    values: {
      field: string;
      label: string;
      aggregation: string;
    };
  };
  sql_query: string;
}

export interface IAiChart {
  config:
    | IBarConfig
    | IStackedAreaConfig
    | IScatterChartConfig
    | ITwoLevelPieChartConfig
    | IRadarChart
    | ISankeyChartConfig
    | ITreeMapChartConfig
    | IStackedBarConfig
    | IBiaxialChartConfig
    | IAreaChartConfig
    | IPieChartConfig;
  chartData: any[];
}

export const formatYAxis = (tick: any) => {
  if (tick >= 1_000_000_000) {
    return `${(tick / 1_000_000_000).toFixed(1)}B`;
  } else if (tick >= 1_000_000) {
    return `${(tick / 1_000_000).toFixed(1)}M`;
  } else if (tick >= 1_000) {
    return `${(tick / 1_000).toFixed(1)}K`;
  }
  return `${tick}`;
};

export const formatXAxis = (tick: string) => {
  const maxLength = 12;
  return tick?.length > maxLength ? tick.slice(0, maxLength) + "…" : tick;
};

export const capitalizeFirstLetter = (text: string) => {
  if (!text) return "";

  return text.charAt(0).toUpperCase() + text.slice(1);
};
